<template>
	<div class="agence">
		<vue-headful
				description="Slumberland s’engage à révéler votre marque, à faire rayonner votre communication et à ré-enchanter votre présence digitale."
				title="Slumberland | L'agence"
		/>

		<!-- Content section -->
		<section class="content_section header_section">

			<div class="baseline">
				“Le pays des rêves”
			</div>

			<div class="intro">
				Slumberland s’engage à révéler votre marque, à faire rayonner votre communication et à ré-enchanter votre
				présence digitale.
			</div>

		</section>
		<!-- /Content section -->

		<!-- Content section -->
		<ContentList
				id="about"
				:columns=1
				alignText="center"
				title="Qui sommes nous"
		>
			<p>
				Slumberland est une agence de création graphique et digitale basée à Paris. Elle est fondée, gérée et développée
				par 3 créatifs associés. Nous accompagnons les entreprises - de la startup aux grands comptes - pour créer des
				plateformes de communication créatives et pertinentes.
			</p>
			<p>
				Crée en 2009 sous le nom Les Quatre Lunes Digitales, l’agence devient Slumberland en 2016.
			</p>

		</ContentList>
		<!-- /Content section -->

		<!-- Content section -->
		<ContentList
				id="services"
				:columns=1
				:contentlistItems="servicesItems"
				alignText="center"
				image="agence_services.jpg"
				imageClass="hidden-md"
				parallax="true"
				title="Services"
		/>
		<!-- /Content section -->

		<!-- Content section -->
		<ContentList
				id="clients"
				:columns=1
				:contentlistItems="clientsItems"
				alignText="center"
				inline="true"
				title="Clients"
		/>
		<!-- /Content section -->

		<!-- Image section -->
		<ImageList
				:imagelistItems="agenceImageItems"
				class="hidden-md"
		/>
		<!-- /Image section -->

		<!-- Content section -->
		<ContentList
				id="teamTitle"
				alignText="center"
				title="L'équipe"
		/>
		<!-- /Content section -->

		<!-- Content section -->
		<ContentList
				id="team"
				:columns=3
				:contentlistItems="equipeItems"
				alignText="center"
				bgColor="#ffdd00"
				headTitle="true"
		/>
		<!-- /Content section -->

	</div>
</template>

<script>

import ContentList from "@/components/ContentList";
import ImageList from "@/components/ImageList";

export default {
	name: "Agence",
	components: {
		ContentList, ImageList
	},
	data() {
		return {
			servicesItems: [
				{
					titre: "Stratégie de marque"
				},
				{
					titre: "Identité visuelle"
				},
				{
					titre: "Conception signalétique"
				},
				{
					titre: "Territoire de marque"
				},
				{
					titre: "Territoire de communication"
				},
				{
					titre: "Stratégie digitale, stratégie multi-sites"
				},
				{
					titre: "UX"
				},
				{
					titre: "Design d'application mobile"
				},
				{
					titre: "Web design"
				},
				{
					titre: "Développement"
				},
				{
					titre: "Brand content"
				},
				{
					titre: "E-Marketing"
				}
			],
			clientsItems: [
				{
					titre: "Société Générale"
				},
				{
					titre: "Dassault Aviation"
				},
				{
					titre: "Sonance Audition"
				},
				{
					titre: "Hopscotch Cinéma"
				},
				{
					titre: "IFCIC"
				},
				{
					titre: "Skyfirst"
				},
				{
					titre: "Ville de Vincennes"
				},
				{
					titre: "Ober"
				},
				{
					titre: "CFAO"
				},
				{
					titre: "UGC"
				},
				{
					titre: "Because Music"
				},
				{
					titre: "Sony Music"
				},
				{
					titre: "RATP"
				},
				{
					titre: "Sénat"
				},
				{
					titre: "Augustinus Bader"
				},
				{
					titre: "Fondation A.R.CA.D"
				},
				{
					titre: "Deauville festival du cinéma américain"
				},
				{
					titre: "Festival du film fantastique Gérarmer"
				},
				{
					titre: "Reims Polar"
				},
				{
					titre: "Biarritz film festival - Nouvelles vagues"
				},
				{
					titre: "Festival America"
				},
				{
					titre: "Festival Nuits de Champagne"
				},
				{
					titre: "Coin de Mire Cinéma"
				}
			],
			equipeItems: [
				{
					name: "Guillaume Tirard",
					fonction: "Directeur de projet digital",
					associe: "Associé",
					image: "gtirard.jpg"
				},
				{
					name: "Lorène Bruant",
					fonction: "Direction artistique",
					associe: "Associée",
					image: "lbruant.jpg"
				},
				{
					name: "Santiago Bordils",
					fonction: "Direction artistique",
					associe: "Associé",
					image: "sbordils.jpg"
				},
				{
					name: "Kilian Sadrin",
					fonction: "Chef de projet digital",
					image: "ksadrin.jpg"
				},
				{
					name: "Charlie Alignan",
					fonction: "Chef de projet digital",
					image: "calignan.jpg"
				}
			],
			agenceImageItems: [
				{
					image: "agence_image_001.jpg"
				},
				{
					image: "agence_image_002.jpg"
				}
			]
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.content_section {

	@include breakpoint(lt-sm) {
		padding: 3.5rem;
	}

	h2 {
		display: inline-block;
		font-family: $IsidoraBold;
		font-size: 4rem;
		margin-bottom: 6rem;
		position: relative;

		&:after {
			background-color: $black;
			bottom: -2rem;
			content: '';
			height: 2px;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 8rem;
		}
	}

	&.header_section {
		align-items: center;
		background-color: $yellow;
		color: $black;
		display: flex;
		flex-direction: column;
		margin-top: $padding-simple;
		padding: 3.5vw 8vw 6vw 8vw;
		text-align: center;

		@include breakpoint(lt-md) {
			margin-left: calc(-100vw / 80);
			margin-right: calc(-100vw / 80);
		}

		.baseline {
			font-family: $IsidoraItalic;
			font-size: calc(7vw / 2.94);
			padding-bottom: 2vw;

			@include breakpoint(lt-sm) {
				font-size: 1.8rem;
			}

			@include breakpoint(xxl) {
				font-size: 4rem;
			}
		}

		.intro {
			font-family: $IsidoraBold;
			font-size: calc(7vw / 1.68);
			max-width: 126rem;

			@include breakpoint(lt-sm) {
				font-size: 3rem;
			}

			@include breakpoint(xxl) {
				font-size: 7rem;
			}
		}
	}

	&#teamTitle {
		padding-bottom: 3rem;
		padding-top: 6rem;
	}
}

</style>
